export default {
  path: 'content',
  name: 'subscription/content',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-content" */ './Content')
}
